import React, { Dispatch, SetStateAction } from "react";

type IsResponsiveMenuDisplayedContext = {
  isResponsiveMenuDisplayed: boolean;
  setIsResponsiveMenuDisplayed: Dispatch<SetStateAction<boolean>>;
};

export default React.createContext<IsResponsiveMenuDisplayedContext>({
  isResponsiveMenuDisplayed: false,
  setIsResponsiveMenuDisplayed: (value) => {},
});
